import $ from "jquery";
import LarvaCachedEvent from "shared/components/recommendation/larva_cached_event";
import { getPlatform } from 'shared/vidio_helpers';

export class SidebarRelatedVideos {
  constructor() {
    this.$recoNode = $("#reco_gravity");
    this.videoId = this.$recoNode.attr("data-video-id");
    this.videoTitle = this.$recoNode.attr("data-video-title");
    this.isLoggedIn = this.$recoNode.attr("data-login") === "true";
    this.userId = this.isLoggedIn
      ? this.$recoNode.attr("data-current-username")
      : undefined;
    this.platform     = getPlatform();
    this.uuid = this.$recoNode.attr("data-recommendation-uuid");
  }

  init() {
    if (this.$recoNode.length === 0) {
      return;
    }

    this.initRecommender();
    this.initCloseButton();
    this.bindClickCloseButton();
  }

  initRecommender() {
    var recommender = new LarvaCachedEvent("larva_related", this.userId);
    recommender.viewVideo(this.videoId);
    recommender.getRecommendations(
      this.videoId,
      this.videoTitle,
      this.platform
    );
  }

  initCloseButton() {
    $("body").on("mouseenter", ".js-reco-gravity", function () {
      $(this).children(".js-video__close-button").removeClass("hide-me");
    });

    $("body").on("mouseleave", ".js-reco-gravity", function () {
      $(this).children(".js-video__close-button").addClass("hide-me");
    });
  }

  bindClickCloseButton() {
    var that = this;
    $("body").on("click", ".js-video__close-button", function () {
      that._recommendationItemCloseAction(that, this);
    });
  }

  _recommendationItemCloseAction(parentContext, currentContext) {
    var selectedVideoId = $(currentContext).next().attr("data-id");
    // send event to ahoy
    var properties = {
      uuid: parentContext.uuid,
      app_name: "vidio",
      login: parentContext.isLoggedIn,
      platform: parentContext.platform,
      video_id: parentContext.videoId,
      removed_video_id: selectedVideoId,
      position: $(currentContext).next().attr("data-position"),
      recommendation_type: $(currentContext)
        .next()
        .attr("data-recommendation-type"),
      recommendation_score: $(currentContext)
        .next()
        .attr("data-recommendation-score"),
      page_name: "watch",
    };

    $.ajax({
      url: `/lateral/add_seen_item?video_id=${selectedVideoId}`,
      method: "POST",
    });
    $(currentContext).parent().fadeOut(400);
    window.AhoyEvent.send("RECOMMENDATION::CLOSE", properties);
  }
}
